"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = refundModalReducer;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var defaultState = _immutable.default.fromJS({
  goodToRefund: {},
  open: false,
  submitRefundError: null,
  submitRefundStatus: _RequestStatusTypes.default.UNINITIALIZED
});

function refundModalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.REFUND_MODAL_OPENED:
      return state.merge({
        goodToRefund: action.payload,
        open: true,
        submitRefundStatus: _RequestStatusTypes.default.UNINITIALIZED
      });

    case _ActionTypes.default.DISMISSED_REFUND_MODAL:
      return defaultState;

    case _ActionTypes.default.REFUND_SUBMITTED:
      if (action.error) {
        return state.merge({
          submitRefundError: action.payload,
          submitRefundStatus: _RequestStatusTypes.default.FAILED
        });
      }

      return state.set('submitRefundStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.REFUND_SUBMITTED_SUCCESS:
      return state.set('submitRefundStatus', _RequestStatusTypes.default.SUCCEEDED);

    default:
      return state;
  }
}

module.exports = exports.default;